"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
var cookie_1 = require("./cookie");
var domain;
var updateActiveTimestamp = function () {
    if (!index_1.cesAuthOptions.authBaseURL) {
        return;
    }
    if (!domain) {
        domain = "." + index_1.cesAuthOptions.authBaseURL.split(".").slice(-2).join(".");
    }
    var currentTime = JSON.stringify(new Date());
    window.localStorage.setItem("activeTimestamp", currentTime);
    cookie_1.setCookie("activeTimestamp", currentTime, domain);
};
exports.default = updateActiveTimestamp;
